import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";

const apiUrl = Config.apiUrl;
const CompanyList = () => {
    let [companies, setCompanies] = useState([]);
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery() {
        try {
            setLoading(true);
            const url = apiUrl + '/api/companies';
            const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
            setCompanies(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        makeQuery();
    }, []);

    return (
        <>
            <div className="header-label">Consulta de Empresas</div>

            <table style={{width: '480px'}}>
                <colgroup>
                    <col style={{width: '60px'}}/>
                    <col/>
                    <col style={{width: '90px'}}/>
                </colgroup>

                <thead>
                <tr>
                    <th>Código</th>
                    <th>Nome</th>
                    <th/>
                </tr>
                </thead>

                <tbody style={{overflowY: 'auto'}}>
                {companies.map((company, index) => (
                    <tr key={index}>
                        <td>{company.id}</td>
                        <td>{company.name}</td>
                        <td>
                            <button onClick={async () => {
                                await navigate('/company?id=' + company.id);
                            }}>Editar
                            </button>
                        </td>
                    </tr>
                ))}
                {companies.length === 0 && <tfoot>Nenhum item encontrado.</tfoot>}
                </tbody>
            </table>
        </>
    );
};

export default CompanyList;
